import { Typography } from 'antd';
import styled from 'styled-components';

export const PriceStyled = styled.div`
	gap: 5px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

export const UnitsStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const PriceContainerStyled = styled.div`
	text-align: right;
`;

export const SpecialPriceStyled = styled.p`
	margin: 0;
	color: #262626;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const ChooseUnitsSummaryPriceStyled = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 24px;
`;

export const PeriodStyled = styled(Typography.Text)`
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
`;
